import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/armsform.css';

const EditLocaldom = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [entry, setEntry] = useState({ ...state.entry, token_id: state.entry.token_id });
    const [error, setError] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEntry((prevEntry) => ({
            ...prevEntry,
            [name]: value,
        }));
    };

    const getDashboardUrl = () => {
        if (state?.userRole === 'admin') {
            return '/admin-dashboard';
        } else if (state?.userRole === 'lduid') {
            return '/local-domicile-dashboard';
        } else {
            console.error('Invalid user role:', state?.userRole);
            return '/local-domicile-dashboard';
        }
    };

    const handleCancel = () => {
        navigate(getDashboardUrl());
    };

    const handleSave = async () => {
        console.log('Entry data before saving:', JSON.stringify(entry, null, 2));
        try {
            const response = await axios.post('https://chaman.gob.pk/eac_backend/edit-localdom.php', {
                action: 'update',
                ...entry,
            });

            console.log('Server response:', response.data);

            if (response.data?.status === 'success') {
                setShowPopup(true);
                setTimeout(() => {
                    setShowPopup(false);
                    navigate(getDashboardUrl());
                }, 2000);
            } else {
                const errorMsg = response.data?.message || 'Failed to update entry';
                setError(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err);
            setError('Error updating entry. Please try again later.');
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form">
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="token_id"
                                value={entry.token_id}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Domicile No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="local_no"
                                value={entry.local_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date"
                                value={entry.date}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="name"
                                value={entry.name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Father Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="father_name"
                                value={entry.father_name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cnic"
                                value={entry.cnic}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="phone_no"
                                value={entry.phone_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Address:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="address"
                                value={entry.address}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">District:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="district"
                                value={entry.district}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Province:</label>
                        <div className="lc-input-container">
                            <select
                                name="province"
                                value={entry.province}
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Province</option>
                                <option value="Balochistan">Balochistan</option>
                                <option value="KPK">KPK</option>
                                <option value="Sindh">Sindh</option>
                                <option value="Punjab">Punjab</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date of Arrival:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date_of_arrival"
                                value={entry.date_of_arrival}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Marital Status:</label>
                        <div className="lc-input-container">
                            <select
                                name="marital_status"
                                value={entry.marital_status}
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Marital Status</option>
                                <option value="Married">Married</option>
                                <option value="Single">Single</option>
                            </select>
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Wife Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="wife_name"
                                value={entry.wife_name}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Husband Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="husband_name"
                                value={entry.husband_name}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Sons Names / Ages:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="sons_names_ages"
                                value={entry.sons_names_ages}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Daughters Names / Ages:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="daughters_names_ages"
                                value={entry.daughters_names_ages}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Trade of Occupation:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="trade_of_occupation"
                                value={entry.trade_of_occupation}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Marks of Identification:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="marks_of_identification"
                                value={entry.marks_of_identification}
                                onChange={handleChange}
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select
                                name="status"
                                value={entry.status}
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Status</option>
                                <option value="Recieved">Recieved</option>
                                <option value="Ready">Ready</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="lc-form-buttons">
                <button type="button" className="lc-submit-btn" onClick={handleSave}>
                    Save
                </button>
                <button type="button" className="lc-cancel-btn" onClick={handleCancel}>
                    Cancel
                </button>
            </div>
            </form>
           
            {error && <div className="lc-error-message">{error}</div>}
            {showPopup && (
                <div className="lc-popup">
                    Entry updated successfully!
                </div>
            )}
        </div>
    );
};

export default EditLocaldom;